import { isSimpleObject } from "../helpers";
import httpService from "./http.service";

class GlassesService {
    getGlassesUrl = "/glasses";
    getGlassesSizesUrl = "/glasses-sizes";
    getGroupOfChange = "/glasses/groupOfChange";

    getGlasses = (query = []) => {
        return httpService.get(`/glasses?${query.join("&")}`);
    };
    createGlasses = (model) => {
        return httpService.post("/glasses", model);
    };
    editGlasses = (id, model) => {
        return httpService.patch("/glasses/" + id, model, "editGlasses");
    };
    seoGlass = (id, model) => {
        return httpService.patch("/glasses/seo/" + id, model, "seoGlass");
    };
    uploadGlassImg = (id, model) => {
        let formData = new FormData();
        model.images.filter(item => item).forEach(it => {
            formData.append("images", it)
        })
        formData.append("deletedFile", JSON.stringify(model.deletedFile))

        return httpService.form("/glasses/gallery/" + id, formData, "uploadGlassImg", {}, "patch");
    };
    updateStocks = (model) => {
        return httpService.patch("/glasses/inventories", model);
    };
    deleteGlasses = (id) => {
        return httpService.delete("/glasses/" + id);
    };

    createGlassesColor = (model) => {
        return httpService.form("/glasses-colors", model, "createGlassesColor");
    };
    editGlassesColor = (id, model) => {
        return httpService.form(
            "/glasses-colors/" + id,
            model,
            "editGlassesColor", {},
            "patch"
        );
    };
    deleteGlassesColor = (id) => {
        return httpService.delete("/glasses-colors/" + id);
    };
    setDiscounts = (model) => {
        return httpService.patch("/glasses-colors/discounts", model);
    };

    createGlassesSize = (model) => {
        return httpService.post("/glasses-sizes", model);
    };
    editGlassesSize = (id, model) => {
        return httpService.patch("/glasses-sizes/" + id, model);
    };
    editGlassesSearchKeys = (id, model) => {
        return httpService.patch("/glasses/search-keys/" + id, model);
    };
    deleteGlassesSize = (id) => {
        return httpService.delete("/glasses-sizes/" + id);
    };
    uploadModel = (id, model) => {
        return httpService.form(
            "/glasses-colors/model/" + id,
            model,
            "uploadModel", {},
            "patch"
        );
    };
    uploadModelCover = (id, model) => {
        return httpService.form(
            "/glasses-colors/model-cover/" + id,
            model,
            "uploadModelCover", {},
            "patch"
        );
    };
    deleteModel = (id) => {
        return httpService.delete(
            "/glasses-colors/model/" + id,
        );
    };
    deleteModelCover = (id) => {
        return httpService.delete(
            "/glasses-colors/model-cover/" + id,
        );
    };

    countOfGlassFilter = (query = []) => {
        return httpService.get(`/glasses/count?${query.join("&")}`);
    }
    handleChangeGrouply = (query = [], body) => {
        return httpService.post(`/glasses/changeGroup?${query.join("&")}`, body);
    }
    handleGetGroupOfChange = (query = []) => {
        return httpService.get(`/glasses/groupOfChange?${query.join("&")}`);
    }
    handleCreateGroupOfChange = (body) => {
        return httpService.post(`/glasses/groupOfChange`, body);
    }
    handleUpdateGroupOfChange = (id, body) => {
        return httpService.patch(`/glasses/groupOfChange/${id}`, body);
    }
    handleDeleteGroupOfChange = (id) => {
        return httpService.delete(`/glasses/groupOfChange/${id}`);
    }
    handleToggleActiveGroupOfChange = (id) => {
        return httpService.post(`/glasses/groupOfChange/toggleActive/${id}`);
    }
}

const glassesService = new GlassesService();
export default glassesService;